import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";

// Legacy /auth route — redirects old ?path= query params to flat routes.
export const Route = createFileRoute("/auth")({
  beforeLoad: ({ search, location }) => {
    if (location.pathname === "/auth/verify") {
      return;
    }
    const legacy = (search as any)?.path as string | undefined;
    if (legacy === "signin") {
      throw redirect({ to: "/signin" });
    }
    if (legacy === "signup") {
      throw redirect({ to: "/register" });
    }
    if (legacy === "forgot-password") {
      throw redirect({ to: "/signin" });
    }
    throw redirect({ to: "/signin" });
  },
  component: Outlet,
});
